export const ROLE_TYPE = {
  STUDENT: "Student",
  INSTRUCTOR: "Instructor",
  ADMIN: "Admin",
}

export const COURSE_STATUS = {
  DRAFT: "Draft",
  PUBLISHED: "Published",
}

export const MAX_FILE_SIZE = {
  IMAGE_KB: 500,
  VIDEO_MB: 10, 
  IMAGE: 500000, // 500 KB
  VIDEO: 10000000 // 10 MB
}
